export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyDUrckEqM9YvaLqzCbWz2NRn0P-TKiT5ec',
    authDomain: 'dev-camed.firebaseapp.com',
    projectId: 'dev-camed',
    storageBucket: 'dev-camed.firebasestorage.app',
    messagingSenderId: '314947867091',
    appId: '1:314947867091:web:27daf841e752fb57b2df26',
  },
  // TODO: Replace with cloud hosted development Base URL
  // This should point to the development Agentic AI service endpoint
  // Example: http://localhost:8080
  // agenticApiBaseUrl: 'http://localhost:8080',
  // agenticApiBaseUrl: 'https://fast-api-314947867091.us-central1.run.app',
  agenticApiBaseUrl: 'https://product-research-https-uawuzflzlq-uc.a.run.app',
};
